import {Component, OnInit, HostBinding} from '@angular/core';
import {Title, Meta} from '@angular/platform-browser';
import {AnimationsMetaData} from '../../_animations/animations.metadata';
import {Subscription} from 'rxjs/Subscription';
import {AnimationService} from '../../_animations/animations.service';
import {RouteDirections, IRouteDirection} from '../../_animations/route-directions.constant';

@Component({
  selector: 'app-disciple',
  providers: [AnimationService, RouteDirections],
  templateUrl: './disciple.component.html',
  styleUrls: ['./disciple.component.css'],
  animations: [AnimationsMetaData]
})
export class DiscipleComponent implements OnInit {
  @HostBinding('@routing') routing;
  @HostBinding('style.display') display = 'block';
  animationServiceEventsSubscription: Subscription;
  public routeDirections: IRouteDirection[];

  constructor(private Title: Title,
              private Meta: Meta,
              private animationService: AnimationService,
              routeDirections: RouteDirections) {
    this.routeDirections = routeDirections.disciple;
  }

  ngOnInit() {
    this.Title.setTitle('Disciple - Work | Alec Bertram');
    this.Meta.addTag({name: 'description', content: 'Disciple is a B2B2C platform that allows creators to grow, engage, and convert their audience around a community application.'});
    this.routing = this.animationService.animationDirection();
    this.animationServiceEventsSubscription = this.animationService.emitCurrentDirection
      .subscribe((direction: any) => this.routing = direction);
  }

  go(direction: string, url: string) {
    return this.animationService.routingService(direction, url);
  }
  pan($event, url: string) {
    return this.animationService.mobileRoutingSerivce($event, url);
  }
}



// WEBPACK FOOTER //
// /opt/buildhome/repo/src/app/work/disciple/disciple.component.ts